import { Routes } from '@enums/Routes'

type Id = string | number

const getThemeRoute = (themeId: Id, courseId: string, educationId: Id) =>
  Routes.THEMES +
  `/${themeId}/course/${courseId.split('/').at(-1)}/education/${educationId}`

export default getThemeRoute
